import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-20 px-side bg-dark flex items-center" }
const _hoisted_2 = { class: "text-xl text-light3 font-black" }
const _hoisted_3 = { class: "text-xl lowercase" }
const _hoisted_4 = { class: "text-xl" }
const _hoisted_5 = { class: "uppercase" }

import { computed } from "vue";
import { useProfileStore } from "@/store/Profile";
import { useScheduleStore } from "@/store/Schedule";
import { useReservation } from "@/composables/reservation";
import { storeToRefs } from "pinia";
import BaseButton from "./Button/BaseButton.vue";
import BUTTONTYPE from "./Button/Button.types";
import UpcomingList from "./Upcoming/UpcomingList.vue";
import { useI18n } from "vue-i18n";

interface Props {
  showUpcoming: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    showUpcoming: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  showUpcoming: boolean;
}



const { t } = useI18n();

const profileStore = useProfileStore();
const scheduleStore = useScheduleStore();

const { nearestUpcomingReservation } = storeToRefs(scheduleStore);

const { startTime } = useReservation(nearestUpcomingReservation);

const nextReservationTitle = computed(() => {
  return nearestUpcomingReservation.value.title ? nearestUpcomingReservation.value.title : t("noTitleFallback");
});

const textStyle = computed(() => {
  return !profileStore.isConnected ? "opacity-50" : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(scheduleStore).upcomingReservations.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_unref(textStyle), "truncate"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeUpcoming')))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("next")) + ": ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(startTime)) + " ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(nextReservationTitle)), 1)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "w-px h-full flex-grow",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeUpcoming')))
    }),
    (_unref(scheduleStore).upcomingReservations.length)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 1,
          type: _unref(BUTTONTYPE).SECONDARY,
          class: "min-w-fit",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('seeUpcoming')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("seeUpcoming")), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (props.showUpcoming)
          ? (_openBlock(), _createBlock(UpcomingList, {
              key: 0,
              "upcoming-list": _unref(scheduleStore).upcomingReservations,
              onCloseUpcoming: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeUpcoming')))
            }, null, 8, ["upcoming-list"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})